import {
  FOLLOW_USER_START,
  SET_CHAT_FOLLOWERS,
  FOLLOW_USER_SUCCESS,
  FOLLOW_USER_FAILURE,
  UNFOLLOW_USER_START,
  UNFOLLOW_USER_SUCCESS,
  UNFOLLOW_USER_FAILURE,
  FETCH_FOLLOWERS_START,
  FETCH_FOLLOWERS_SUCCESS,
  FETCH_FOLLOWERS_FAILURE,
  FETCH_ACTIVE_FOLLOWERS_START,
  FETCH_ACTIVE_FOLLOWERS_SUCCESS,
  FETCH_ACTIVE_FOLLOWERS_FAILURE,
  FETCH_EXPIRED_FOLLOWERS_START,
  FETCH_EXPIRED_FOLLOWERS_SUCCESS,
  FETCH_EXPIRED_FOLLOWERS_FAILURE,
  FETCH_FOLLOWING_START,
  FETCH_FOLLOWING_SUCCESS,
  FETCH_FOLLOWING_FAILURE,
  FETCH_ACTIVE_FOLLOWING_START,
  FETCH_ACTIVE_FOLLOWING_SUCCESS,
  FETCH_ACTIVE_FOLLOWING_FAILURE,
  FETCH_EXPIRED_FOLLOWING_START,
  FETCH_EXPIRED_FOLLOWING_SUCCESS,
  FETCH_EXPIRED_FOLLOWING_FAILURE,
} from "../actions/ActionConstant";

const initialState = {
  followUser: {
    data: {},
    loading: false,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  unFollowUser: {
    data: {},
    loading: false,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  followers: {
    data: {},
    page: 1,
    limit: 12,
    hasNext: false,
    inputData: {},
    loading: true,
    error: false,
  },
  activeFollowers: {
    data: {},
    page: 1,
    limit: 12,
    hasNext: false,
    inputData: {},
    loading: true,
    error: false,
  },
  expiredFollowers: {
    data: {},
    loading: true,
    page: 1,
    limit: 12,
    hasNext: false,
    inputData: {},
    error: false,
  },
  following: {
    data: {},
    page: 1,
    limit: 12,
    hasNext: false,
    inputData: {},
    loading: false,
    error: false,
  },
  activeFollowing: {
    data: {},
    page: 1,
    limit: 12,
    hasNext: false,
    inputData: {},
    loading: false,
    error: false,
  },
  expiredFollowing: {
    data: {},
    page: 1,
    limit: 12,
    hasNext: false,
    inputData: {},
    loading: false,
    error: false,
  },
  chatFollowers: {
    data: [],
    loading: true,
  }
};

const FollowReducer = (state = initialState, action) => {
  switch (action.type) {
    case FOLLOW_USER_START:
      return {
        ...state,
        followUser: {
          data: {},
          loading: true,
          error: false,
          inputData: action.data,
          loadingButtonContent: "Loading... Please wait.",
          buttonDisable: true,
        },
      };
    case FOLLOW_USER_SUCCESS:
      return {
        ...state,
        followUser: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case FOLLOW_USER_FAILURE:
      return {
        ...state,
        followUser: {
          data: {},
          loading: false,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case UNFOLLOW_USER_START:
      return {
        ...state,
        unFollowUser: {
          data: {},
          loading: true,
          error: false,
          inputData: action.data,
          loadingButtonContent: "Loading... Please wait.",
          buttonDisable: true,
        },
      };
    case UNFOLLOW_USER_SUCCESS:
      return {
        ...state,
        unFollowUser: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case UNFOLLOW_USER_FAILURE:
      return {
        ...state,
        unFollowUser: {
          data: {},
          loading: false,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case FETCH_FOLLOWERS_START:
      return {
        ...state,
        followers: {
          ...state.followers,
          data: {
            ...state.followers.data,
            followers: action.data && action.data.page != 1 ? state.followers.data?.followers : []
          },
          inputData: action.data,
          loading: true,
          error: false,
        },
      };
    case FETCH_FOLLOWERS_SUCCESS:
      return {
        ...state,
        followers: {
          ...state.followers,
          data: {
            ...action.data,
            followers: [
              ...state.followers.data.followers,
              ...action.data.followers
            ]
          },
          page: parseInt(action.data.pagination.current_page),
          hasNext: action.data.pagination.next_page ? true : false,
          inputData: {},
          loading: false,
          error: false,
        },
      };
    case FETCH_FOLLOWERS_FAILURE:
      return {
        ...state,
        followers: {
          ...state.followers,
          inputData: {},
          loading: false,
          error: action.error,
        },
      };

    case FETCH_ACTIVE_FOLLOWERS_START:
      return {
        ...state,
        activeFollowers: {
          ...state.activeFollowers,
          data: {
            ...state.activeFollowers.data,
            followers: action.data && action.data.page != 1 ? state.activeFollowers.data?.followers : []
          },
          inputData: action.data,
          loading: true,
          error: false,
        },
      };
    case FETCH_ACTIVE_FOLLOWERS_SUCCESS:
      return {
        ...state,
        activeFollowers: {
          ...state.activeFollowers,
          data: {
            ...action.data,
            followers: [
              ...state.activeFollowers.data.followers,
              ...action.data.followers
            ]
          },
          page: parseInt(action.data.pagination.current_page),
          hasNext: action.data.pagination.next_page ? true : false,
          inputData: {},
          loading: false,
          error: false,
        },
      };
    case FETCH_ACTIVE_FOLLOWERS_FAILURE:
      return {
        ...state,
        activeFollowers: {
          ...state.activeFollowers,
          inputData: {},
          loading: false,
          error: action.error,
        },
      };
    case FETCH_EXPIRED_FOLLOWERS_START:
      return {
        ...state,
        expiredFollowers: {
          ...state.expiredFollowers,
          data: {
            ...state.expiredFollowers.data,
            followers: action.data && action.data.page != 1 ? state.expiredFollowers.data?.followers : []
          },
          inputData: action.data,
          loading: true,
          error: false,
        },
      };
    case FETCH_EXPIRED_FOLLOWERS_SUCCESS:
      return {
        ...state,
        expiredFollowers: {
          ...state.expiredFollowers,
          data: {
            ...action.data,
            followers: [
              ...state.expiredFollowers.data.followers,
              ...action.data.followers
            ]
          },
          page: parseInt(action.data.pagination.current_page),
          hasNext: action.data.pagination.next_page ? true : false,
          inputData: {},
          loading: false,
          error: false,
        },
      };
    case FETCH_EXPIRED_FOLLOWERS_FAILURE:
      return {
        ...state,
        expiredFollowers: {
          ...state.expiredFollowers,
          inputData: {},
          loading: false,
          loading: true,
          error: action.error,
        },
      };
    case FETCH_FOLLOWING_START:
      return {
        ...state,
        following: {
          ...state.following,
          data: {
            ...state.following.data,
            followings: action.data && action.data.page != 1 ? state.following.data?.followings : []
          },
          inputData: action.data,
          loading: true,
          error: false,
        },
      };
    case FETCH_FOLLOWING_SUCCESS:
      return {
        ...state,
        following: {
          ...state.following,
          data: {
            ...action.data,
            followings: [
              ...state.following.data.followings,
              ...action.data.followings
            ]
          },
          page: parseInt(action.data.pagination.current_page),
          hasNext: action.data.pagination.next_page ? true : false,
          inputData: {},
          loading: false,
          error: false,
        },
      };
    case FETCH_FOLLOWING_FAILURE:
      return {
        ...state,
        following: {
          ...state.following,
          inputData: {},
          loading: false,
          error: action.error,
        },
      };
    case FETCH_ACTIVE_FOLLOWING_START:
      return {
        ...state,
        activeFollowing: {
          ...state.activeFollowing,
          data: {
            ...state.activeFollowing.data,
            followings: action.data && action.data.page != 1 ? state.activeFollowing.data?.followings : []
          },
          inputData: action.data,
          loading: true,
          error: false,
        },
      };
    case FETCH_ACTIVE_FOLLOWING_SUCCESS:
      return {
        ...state,
        activeFollowing: {
          ...state.activeFollowing,
          data: {
            ...action.data,
            followings: [
              ...state.activeFollowing.data.followings,
              ...action.data.followings
            ]
          },
          page: parseInt(action.data.pagination.current_page),
          hasNext: action.data.pagination.next_page ? true : false,
          inputData: {},
          loading: false,
          error: false,
        },
      };
    case FETCH_ACTIVE_FOLLOWING_FAILURE:
      return {
        ...state,
        activeFollowing: {
          ...state.activeFollowing,
          inputData: {},
          loading: true,
          error: action.error,
        },
      };
    case FETCH_EXPIRED_FOLLOWING_START:
      return {
        ...state,
        expiredFollowing: {
          ...state.expiredFollowing,
          data: {
            ...state.expiredFollowing.data,
            followings: action.data && action.data.page != 1 ? state.expiredFollowing.data?.followings : []
          },
          inputData: action.data,
          loading: true,
          error: false,
        },
      };
    case FETCH_EXPIRED_FOLLOWING_SUCCESS:
      return {
        ...state,
        expiredFollowing: {
          ...state.expiredFollowing,
          data: {
            ...action.data,
            followings: [
              ...state.expiredFollowing.data.followings,
              ...action.data.followings
            ]
          },
          page: parseInt(action.data.pagination.current_page),
          hasNext: action.data.pagination.next_page ? true : false,
          inputData: {},
          loading: false,
          error: false,
        },
      };
    case FETCH_EXPIRED_FOLLOWING_FAILURE:
      return {
        ...state,
        expiredFollowing: {
          inputData: {},
          loading: true,
          error: action.error,
        },
      };
    case SET_CHAT_FOLLOWERS:
      return {
        ...state,
        chatFollowers: {
          data: action.data,
        },
      };
    default:
      return state;
  }
};

export default FollowReducer;
